<div class="append-container" style="height: 30px;" #container></div>
<form class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
    <fieldset class="k-form-fieldset">

        <!-- Entidade -->
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="refEntidade" [text]="customMsgService.translate('entidade')">
            </kendo-label>
            <kendo-dropdownlist formControlName="refEntidade" textField="nome" valueField="id"
                (selectionChange)="selectionChangeEntidade($event)" [data]="listItemsEntidades" #refEntidade>
            </kendo-dropdownlist>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('entidade') }} {{ customMsgService.translate('isRequired')
                }}</kendo-formerror>
        </kendo-formfield>

        <!-- Nome -->
        <kendo-formfield orientation="horizontal">
            <kendo-label [for]="nome" [text]="customMsgService.translate('name')"> </kendo-label>
            <kendo-textbox formControlName="nome" [clearButton]="true" #nome required> </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('name') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
        </kendo-formfield>

        <!-- Codigo de Funcionario -->
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="codigoDeFuncionario"
                [text]="customMsgService.translate('employeeCode')"> </kendo-label>
            <kendo-textbox formControlName="codigoDeFuncionario" [clearButton]="true" #codigoDeFuncionario required>
            </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('employeeCode') }} {{ customMsgService.translate('isRequired')
                }}</kendo-formerror>
        </kendo-formfield>

        <!-- Cartao -->
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="idCartao" [text]="customMsgService.translate('cardID')"> </kendo-label>
            <kendo-textbox formControlName="idCartao" [clearButton]="true" #idCartao required> </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('cardID') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
        </kendo-formfield>

        <!-- balão de Informação de Funcao -->
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="idFuncao" [text]="customMsgService.translate('jobTitle')">
                <div kendoTooltip style="text-align: center; padding-top: 10px;">
                    <button kendoButton type="button" rounded="full" icon="help" fillMode="clear" size="small" title="{{cargos()}}">
                    </button>
                </div>
            </kendo-label>

            <!-- Funcao -->
            <kendo-dropdownlist formControlName="idFuncao" textField="description" valueField="id"
                (selectionChange)=" selectionChangeEquipas($event); selectionChangeEmail($event)" [data]="listItemsPerfil" #idFuncao required><!-- selectionChangeEmail($event); -->
            </kendo-dropdownlist>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('jobTitle') }} {{ customMsgService.translate('isRequired')
                }}</kendo-formerror>
        </kendo-formfield>

        <!-- Equipas -->
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="iDsEquipas" [text]="customMsgService.translate('teams')"> </kendo-label>
            <kendo-multiselect formControlName="iDsEquipas" textField="nome" valueField="id"  [data]="listItemsEquipas"
                #iDsEquipas>
            </kendo-multiselect>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('teams') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
        </kendo-formfield>

        <!-- Linguas -->
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="idLingua" [text]="customMsgService.translate('ligua')"> </kendo-label>
            <kendo-dropdownlist formControlName="idLingua" textField="description" valueField="id"
                [data]="listItemsLinguas" #idLingua required>
            </kendo-dropdownlist>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('ligua') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
        </kendo-formfield>

        <!-- Telefone -->
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="telemovel" [text]="customMsgService.translate('phone')"> </kendo-label>
            <kendo-textbox formControlName="telemovel" [clearButton]="true" #telemovel> </kendo-textbox>
        </kendo-formfield>


        <!-- balão de Informação de Email -->
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="email" [text]="customMsgService.translate('email')">
                <div kendoTooltip style="text-align: center; padding-top: 10px;">
                    <button kendoButton type="button" rounded="full" icon="help" fillMode="clear" size="small" title="{{infoEmail()}}">
                    </button>
                </div>
            </kendo-label>

            <!-- Email -->
            <kendo-textbox formControlName="email" [clearButton]="true" #email> </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('email') }} {{ customMsgService.translate('isRequired')
                }}</kendo-formerror>
        </kendo-formfield>

        <!-- Email -->
<!--         <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="email" [text]="customMsgService.translate('email')"> </kendo-label>
            <kendo-textbox formControlName="email" [clearButton]="true" #email> </kendo-textbox>
        </kendo-formfield>
 -->
        <!-- Data de Nascimento -->
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="validade" [text]="customMsgService.translate('validade')">
            </kendo-label>
            <kendo-datepicker formControlName="validade" #validade></kendo-datepicker>
        </kendo-formfield>

        <!-- Data de Admissao -->
        <kendo-dialog-actions>
            <button kendoButton (click)="cancelChanges()">
                {{ customMsgService.translate('cancel') }}
            </button>
            <button kendoButton (click)="saveChanges()" themeColor="primary" [disabled]="!formGroup.valid">
                {{ customMsgService.translate('saveChanges') }}
            </button>
        </kendo-dialog-actions>

    </fieldset>
</form>